module.exports = __webpack_public_path__ + "static/media/john-maeda-1990.a973ddb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/presentation/john-maeda-1990.jpg
// module id = 431
// module chunks = 12